<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.33 8.44375H1V4.88875C1 4.39772 1.39772 4 1.88875 4H21.4412C21.9323 4 22.33 4.39772 22.33 4.88875V8.44375Z" fill="#C60B1E"/>
<path d="M22.33 8.44373H1V15.5537H22.33V8.44373Z" fill="#FFC300"/>
<path d="M22.33 19.1088C22.33 19.5998 21.9323 19.9975 21.4412 19.9975H1.88875C1.39772 19.9975 1 19.5998 1 19.1088V15.5538H22.33V19.1088Z" fill="#C60B1E"/>
<path d="M7.22125 10.2213V9.33252H3.66625V10.2213H4.555V11.11H3.66625V13.4794L5.44375 14.665L7.22125 13.4794V11.11H6.3325V10.2213H7.22125Z" fill="#91443A"/>
</svg>
